import type { ThemeSchemaResponse } from '@api/api/theme-overview';
import { CompanyRanking } from './company-ranking/CompanyRanking';
import styles from './IndustryDrawerContent.module.scss';
import { MonthlySentiment } from './monthly-sentiment/MonthlySentiment';
import { RecentUpdates } from './recent-updates/RecentUpdates';
import { UpcomingEarnings } from './upcoming-earnings/UpcomingEarnings';

export interface IndustryDrawerContentProps {
  theme: ThemeSchemaResponse;
}

export const IndustryDrawerContent = ({
  theme,
}: IndustryDrawerContentProps) => {
  const themeId = theme.id;

  return (
    <div className={styles.root}>
      <RecentUpdates themeId={themeId} />
      <CompanyRanking themeId={themeId} />
      <UpcomingEarnings themeId={themeId} />
      <MonthlySentiment theme={theme} />
    </div>
  );
};
